var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"container lnb d_container"},[_c('div',{staticClass:"contents_wrap no_height"},[_c('div',{staticClass:"contents list-container"},[_c('div',{staticClass:"title"},[_vm._v("탈퇴회원")]),_c('div',[_c('member-list-component',{attrs:{"member-type":`quit`}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }